/* eslint-disable */
import { PluginContainerData } from './common';
const baseGIFData = { height: 0, width: 0 };
export const GIFData = {
    fromJSON(object) {
        const message = Object.assign({}, baseGIFData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.original =
            object.original !== undefined && object.original !== null
                ? GIF.fromJSON(object.original)
                : undefined;
        message.downsized =
            object.downsized !== undefined && object.downsized !== null
                ? GIF.fromJSON(object.downsized)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? Number(object.height) : 0;
        message.width = object.width !== undefined && object.width !== null ? Number(object.width) : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.original !== undefined &&
            (obj.original = message.original ? GIF.toJSON(message.original) : undefined);
        message.downsized !== undefined &&
            (obj.downsized = message.downsized ? GIF.toJSON(message.downsized) : undefined);
        message.height !== undefined && (obj.height = Math.round(message.height));
        message.width !== undefined && (obj.width = Math.round(message.width));
        return obj;
    },
};
const baseGIF = {};
export const GIF = {
    fromJSON(object) {
        const message = Object.assign({}, baseGIF);
        message.gif = object.gif !== undefined && object.gif !== null ? String(object.gif) : undefined;
        message.mp4 = object.mp4 !== undefined && object.mp4 !== null ? String(object.mp4) : undefined;
        message.still =
            object.still !== undefined && object.still !== null ? String(object.still) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.gif !== undefined && (obj.gif = message.gif);
        message.mp4 !== undefined && (obj.mp4 = message.mp4);
        message.still !== undefined && (obj.still = message.still);
        return obj;
    },
};
//# sourceMappingURL=plugin_gif.js.map